// import React from "react";
import Header from "../directives/header";
import Footer from "../directives/footer";

function Home() {
  return (
    <>
      <Header />
      <div className="container-fluid bg-primary px-0 px-md-5 mb-5">
        <div className="row align-items-center px-3">
          <div className="col-lg-6 text-center text-lg-left">
            <h4 className="text-white mb-4 mt-5 mt-lg-0">
              Kids Learning Center
            </h4>
            <h1 className="display-3 font-weight-bold text-white">
              New Approach to Kids Education
            </h1>
            <p className="text-white mb-4">
              Sea ipsum kasd eirmod kasd magna, est sea et diam ipsum est amet
              sed sit. Ipsum dolor no justo dolor et, lorem ut dolor erat dolore
              sed ipsum at ipsum nonumy amet. Clita lorem dolore sed stet et est
              justo dolore.
            </p>
            <a href="#contactUs" className="btn btn-secondary mt-1 py-3 px-5">
              Contact Us
            </a>
          </div>
          <div className="col-lg-6 text-center text-lg-right">
            <img
              className="img-fluid mt-5"
              src="assets/img/header.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <>
        {/* Facilities Start */}
        <div className="container-fluid pt-5">
          <div className="container pb-3">
            <div className="row">
              <div className="col-lg-4 col-md-6 pb-1">
                <div
                  className="d-flex bg-light shadow-sm border-top rounded mb-4"
                  style={{ padding: 30 }}
                >
                  <i className="flaticon-050-fence h1 font-weight-normal text-primary mb-3" />
                  <div className="pl-4">
                    <h4>Play Ground</h4>
                    <p className="m-0">
                      Kasd labore kasd et dolor est rebum dolor ut, clita dolor
                      vero lorem amet elitr vero...
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 pb-1">
                <div
                  className="d-flex bg-light shadow-sm border-top rounded mb-4"
                  style={{ padding: 30 }}
                >
                  <i className="flaticon-022-drum h1 font-weight-normal text-primary mb-3" />
                  <div className="pl-4">
                    <h4>Music and Dance</h4>
                    <p className="m-0">
                      Kasd labore kasd et dolor est rebum dolor ut, clita dolor
                      vero lorem amet elitr vero...
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 pb-1">
                <div
                  className="d-flex bg-light shadow-sm border-top rounded mb-4"
                  style={{ padding: 30 }}
                >
                  <i className="flaticon-030-crayons h1 font-weight-normal text-primary mb-3" />
                  <div className="pl-4">
                    <h4>Arts and Crafts</h4>
                    <p className="m-0">
                      Kasd labore kasd et dolor est rebum dolor ut, clita dolor
                      vero lorem amet elitr vero...
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 pb-1">
                <div
                  className="d-flex bg-light shadow-sm border-top rounded mb-4"
                  style={{ padding: 30 }}
                >
                  <i className="flaticon-017-toy-car h1 font-weight-normal text-primary mb-3" />
                  <div className="pl-4">
                    <h4>Safe Transportation</h4>
                    <p className="m-0">
                      Kasd labore kasd et dolor est rebum dolor ut, clita dolor
                      vero lorem amet elitr vero...
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 pb-1">
                <div
                  className="d-flex bg-light shadow-sm border-top rounded mb-4"
                  style={{ padding: 30 }}
                >
                  <i className="flaticon-025-sandwich h1 font-weight-normal text-primary mb-3" />
                  <div className="pl-4">
                    <h4>Healthy food</h4>
                    <p className="m-0">
                      Kasd labore kasd et dolor est rebum dolor ut, clita dolor
                      vero lorem amet elitr vero...
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 pb-1">
                <div
                  className="d-flex bg-light shadow-sm border-top rounded mb-4"
                  style={{ padding: 30 }}
                >
                  <i className="flaticon-047-backpack h1 font-weight-normal text-primary mb-3" />
                  <div className="pl-4">
                    <h4>Educational Tour</h4>
                    <p className="m-0">
                      Kasd labore kasd et dolor est rebum dolor ut, clita dolor
                      vero lorem amet elitr vero...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Facilities Start */}
      </>

      {/* About Start */}
      <div className="container-fluid py-5" id="aboutUs">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <img
                className="img-fluid rounded mb-5 mb-lg-0"
                src="assets/gallery/1.jpeg"
                alt=""
              />
            </div>
            <div className="col-lg-7">
              <p className="section-title pr-5">
                <span className="pr-2"> About Us</span>
              </p>
              <h1 className="mb-4">Best School For Your Kids</h1>
              <p>
                Invidunt lorem justo sanctus clita. Erat lorem labore ea, justo
                dolor lorem ipsum ut sed eos, ipsum et dolor kasd sit ea justo.
                Erat justo sed sed diam. Ea et erat ut sed diam sea ipsum est
                dolor
              </p>
              <div className="row pt-2 pb-4">
                {/* <div className="col-6 col-md-4">
                  <img
                    className="img-fluid rounded"
                    src="assets/img/about-2.jpg"
                    alt=""
                  />
                </div> */}
                <div className="col-6 col-md-8">
                  <ul className="list-inline m-0">
                    <li className="py-2 border-top border-bottom">
                      <i className="fa fa-check text-primary mr-3" />
                      New approch for study
                    </li>
                    <li className="py-2 border-bottom">
                      <i className="fa fa-check text-primary mr-3" />
                      Kids personality development
                    </li>
                    <li className="py-2 border-bottom">
                      <i className="fa fa-check text-primary mr-3" />
                      98% results
                    </li>
                  </ul>
                </div>
              </div>
              {/* <a href="" className="btn btn-primary mt-2 py-2 px-4">
                  Learn More
                </a> */}
            </div>
          </div>
        </div>
      </div>
      {/* About End */}

      {/* Gallery Start */}
      <div className="container-fluid pt-5 pb-3" id="gallery">
        <div className="container">
          <div className="text-center pb-2">
            <p className="section-title px-5">
              <span className="px-2">Our Gallery</span>
            </p>
            <h1 className="mb-4">Our Kids School Gallery</h1>
          </div>
          {/* <div className="row">
            <div className="col-12 text-center mb-2">
              <ul className="list-inline mb-4" id="portfolio-flters">
                <li
                  className="btn btn-outline-primary m-1 active"
                  data-filter="*"
                >
                  All
                </li>
                <li
                  className="btn btn-outline-primary m-1"
                  data-filter=".first"
                >
                  Playing
                </li>
                <li
                  className="btn btn-outline-primary m-1"
                  data-filter=".second"
                >
                  Drawing
                </li>
                <li
                  className="btn btn-outline-primary m-1"
                  data-filter=".third"
                >
                  Reading
                </li>
              </ul>
            </div>
          </div> */}
          <div className="row portfolio-container">
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item first">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/1.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                    target="__blank" href="assets/gallery/1.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item second">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/2.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                    target="__blank" href="assets/gallery/2.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item third">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/3.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                    target="__blank" href="assets/gallery/3.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item first">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/3.2.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                    target="__blank" href="assets/gallery/3.2.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item second">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/4.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                    target="__blank" href="assets/gallery/4.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item third">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/5.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                    target="__blank" href="assets/gallery/5.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item second">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/6.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                    target="__blank" href="assets/gallery/6.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item second">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/7.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                    target="__blank" href="assets/gallery/7.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4 col-md-6 mb-4 portfolio-item second">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/8.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                   target="__blank" href="assets/gallery/8.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 portfolio-item second">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/9.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                   target="__blank" href="assets/gallery/9.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div> */}
            {/* <div className="col-lg-4 col-md-6 mb-4 portfolio-item second">
              <div className="position-relative overflow-hidden mb-2">
                <img
                  className="img-fluid w-100"
                  src="assets/gallery/10.jpeg"
                  alt=""
                />
                <div className="portfolio-btn bg-primary d-flex align-items-center justify-content-center">
                  <a
                   target="__blank" href="assets/gallery/10.jpeg"
                    data-lightbox="portfolio"
                  >
                    <i
                      className="fa fa-plus text-white"
                      style={{ fontSize: 60 }}
                    />
                  </a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* Gallery End */}

      {/* Contact Start */}
      <div className="container-fluid pt-5" id="contactUs">
        <div className="container">
          <div className="text-center pb-2">
            <p className="section-title px-5">
              <span className="px-2">Get In Touch</span>
            </p>
            <h1 className="mb-4">Contact Us For Any Query</h1>
          </div>
          <div className="row">
            <div className="col-lg-7 mb-5">
              <div className="contact-form">
                <div id="success" />
                <form name="sentMessage" id="contactForm" noValidate>
                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Your Name"
                      required
                      data-validation-required-message="Please enter your name"
                    />
                    <p className="help-block text-danger" />
                  </div>
                  <div className="control-group">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Your Email"
                      required
                      data-validation-required-message="Please enter your email"
                    />
                    <p className="help-block text-danger" />
                  </div>
                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control"
                      id="subject"
                      placeholder="Subject"
                      required
                      data-validation-required-message="Please enter a subject"
                    />
                    <p className="help-block text-danger" />
                  </div>
                  <div className="control-group">
                    <textarea
                      className="form-control"
                      rows={6}
                      id="message"
                      placeholder="Message"
                      required
                      data-validation-required-message="Please enter your message"
                      defaultValue={""}
                    />
                    <p className="help-block text-danger" />
                  </div>
                  <div>
                    <button
                      className="btn btn-primary py-2 px-4"
                      type="submit"
                      id="sendMessageButton"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-5 mb-5">
              <p>
                Labore sea amet kasd diam justo amet ut vero justo. Ipsum ut et
                kasd duo sit, ipsum sea et erat est dolore, magna ipsum et magna
                elitr. Accusam accusam lorem magna, eos et sed eirmod dolor est
                eirmod eirmod amet.
              </p>
              <div className="d-flex">
                <i
                  className="fa fa-map-marker-alt d-inline-flex align-items-center justify-content-center bg-primary text-secondary rounded-circle"
                  style={{ width: 45, height: 45 }}
                />
                <div className="pl-3">
                  <h5>Address</h5>
                  <p>Bhaugarh, Chupna Bypass Road, Teh. Dalouda</p>
                </div>
              </div>
              <div className="d-flex">
                <i
                  className="fa fa-envelope d-inline-flex align-items-center justify-content-center bg-primary text-secondary rounded-circle"
                  style={{ width: 45, height: 45 }}
                />
                <div className="pl-3">
                  <h5>Email</h5>
                  <p><a href="mailto:vvmbhaugarh614301@Gmail.com"> vvmbhaugarh614301@Gmail.com</a></p>
                </div>
              </div>
              <div className="d-flex">
                <i
                  className="fa fa-phone-alt d-inline-flex align-items-center justify-content-center bg-primary text-secondary rounded-circle"
                  style={{ width: 45, height: 45 }}
                />
                <div className="pl-3">
                  <h5>Phone</h5>
                  <p> Office : &nbsp;
                    <a href="tel:07422298023">
                      07422298023,
                    </a>
                  </p>
                  <p> Director : &nbsp;
                    <a href="tel:07422298023">
                      8827960927
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}

      <Footer />
    </>
  );
}

export default Home;
